export const NAMESPACE_LIST = ['pw_keys', 'info', 'paygoups_and_processing_time', 'errors', 'decline'];

const CASHIER_SERVICE_ENV = process.env.NODE_ENV === 'production' ? '/api/cashier-service/' : '/cash-ph20-service/';
export const WIDGET_API = `${CASHIER_SERVICE_ENV}v1.0`;

export const FLOW_ENDPOINTS: Record<'deposit' | 'withdrawal', string> = {
  deposit: 'payments',
  withdrawal: 'payouts',
};
